import PrimaryButton from "../components/PrimaryButton";
import { CardSubtitle, CardTitle, IconBadge, Notice } from "../components/AuthCard";
import { ClockIcon, LockIcon } from "../components/Icons";
import { LOCK_MINUTES, MAX_OTP_ATTEMPTS } from "../constants";
import { formatTimer, useCountdown } from "../utils";

// A7 — shared by both flows
const OtpLocked = ({ lockedUntil, onBack }) => {
  const [remaining] = useCountdown(() =>
    Math.max(0, Math.ceil((lockedUntil - Date.now()) / 1000)),
  );

  return (
    <div className="flex flex-col items-center text-center">
      <IconBadge tone="red" className="!w-[60px] !h-[60px] mb-2.5">
        <LockIcon />
      </IconBadge>
      <CardTitle>Too many attempts</CardTitle>
      <CardSubtitle className="!text-[13px] !leading-[18px]">
        For your security, OTP verification has been paused for {LOCK_MINUTES}{" "}
        minutes after {MAX_OTP_ATTEMPTS} incorrect attempts.
      </CardSubtitle>

      <Notice
        tone="amber"
        icon={<ClockIcon className="w-3.5 h-3.5 text-[#B4540A]" />}
        className="w-full mt-3.5 text-left"
      >
        {remaining > 0 ? (
          <>
            You can try again in{" "}
            <span className="font-geomanistBold tabular-nums">
              {formatTimer(remaining)}
            </span>
            .
          </>
        ) : (
          "You can try again now."
        )}
      </Notice>

      <div className="w-full mt-3">
        <PrimaryButton title="Back to login" onClick={onBack} />
      </div>
    </div>
  );
};

export default OtpLocked;
